<div class="modal-header">
  <h4 class="modal-title">
    {{ 'settingsTabNavigator.label.speedway_settings' | translate }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner" maxHeightOffset>
    <form [formGroup]="form" *ngIf="form">
      <div>
        <p class="font-weight-bold">{{'settingsTabNavigator.label.supplied_current_bus_750_753' | translate}}</p>
        <div class="mb-3 row" *ngIf="form.controls.logicAndSensorCurrentCarryover">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.logic_and_sensors_750_753' | translate}}:</label>
          <div class="col-md-8">
            <div class="form-control break-all" [ngClass]="form.controls.logicAndSensorCurrentCarryover.invalid ? 'is-invalid' : 'border-white'">
              {{form.controls.logicAndSensorCurrentCarryover.value}}
            </div>
            <div class="invalid-feedback">
              {{ form.controls.logicAndSensorCurrentCarryover.errors?.messageKey | translate:{'0':form.controls.logicAndSensorCurrentCarryover.errors?.param} }}
            </div>
          </div>
        </div>
        <div class="mb-3 row" *ngIf="form.controls.actuatorCurrentCarryover">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.actuators_750_753' | translate}}:</label>
          <div class="col-md-8">
            <div class="form-control break-all" [ngClass]="form.controls.actuatorCurrentCarryover.invalid ? 'is-invalid' : 'border-white'">
              {{form.controls.actuatorCurrentCarryover.value}}
            </div>
            <div class="invalid-feedback">
              {{ form.controls.actuatorCurrentCarryover.errors?.messageKey | translate:{'0':form.controls.actuatorCurrentCarryover.errors?.param} }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!busKopplerModule && hasInputMode() && hasCurrentChannels()">
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.consumers' | translate}}:</label>
          <div class="col-md-8">
            <select class="form-control" id="isDetailedEntryForCurrentConsumption750_753InputItem"
              formControlName="isDetailedEntryForCurrentConsumption750_753InputItem"
              (change)="detailedEntryForCurrentConsumptionChangedHandler()">
              <option [value]="1">{{'settingsTabNavigator.label.enter_details' | translate}}</option>
              <option [value]="0">{{'settingsTabNavigator.label.enter_sums' | translate}}</option>
            </select>
          </div>
        </div>
      </div>

      <div *ngIf="!busKopplerModule">
        <p class="font-weight-bold">{{'settingsTabNavigator.label.actuator_current_bus_750_753' | translate}}</p>
        <div class="mb-3 row" *ngFor="let item of channeldataProvider">
          <label class="col-md-4 col-form-label text-end break-all">
            {{item.propertyLabel}}{{item.propertyDescription ? ' (' + item.propertyDescription + ')' : ''}}:
          </label>
          <div class="col-md-8 d-flex">
            <div class="w-100">
              <input class="form-control" type="text"
                inputRestricter="{{item.inputRestricter}}"
                (inputEvent)="form.controls[item.propertyLabel]?.setValue($event)"
                formControlName="{{item.propertyLabel}}"
                [class.is-invalid]="form.controls[item.propertyLabel]?.invalid"
                [readonly]="!editProjectPermission">
              <div class="invalid-feedback">
                {{ form.controls[item.propertyLabel]?.errors?.messageKey | translate:{'0':form.controls[item.propertyLabel]?.errors?.param} }}
              </div>
            </div>
            <div class="ps-2 pt-1" *ngIf="item.descriptionEditable">
              <i class="fa fa-pencil-alt cpointer" tooltip tooltipPosition="bottom" (click)="editDescription(item)"
                [tooltipText]="'propertyInputSuperTabContentItem.tooltip.edit_description' | translate"></i>
            </div>
          </div>
        </div>

        <div class="mb-3 row" *ngIf="form.controls.totalInternalActuatorCurrentConsumption">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.internal' | translate}}:</label>
          <div class="col-md-8">
            <div class="form-control break-all" [ngClass]="form.controls.totalInternalActuatorCurrentConsumption.invalid ? 'is-invalid' : 'border-white'">
              {{form.controls.totalInternalActuatorCurrentConsumption.value}}
            </div>
            <div class="invalid-feedback">
              {{ form.controls.totalInternalActuatorCurrentConsumption.errors?.messageKey | translate:{'0':form.controls.totalInternalActuatorCurrentConsumption.errors?.param} }}
            </div>
          </div>
        </div>
        <div class="mb-3 row" *ngIf="form.controls.totalActuatorCurrentConsumption">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.total' | translate}}:</label>
          <div class="col-md-8">
            <div class="form-control break-all" [ngClass]="form.controls.totalActuatorCurrentConsumption.invalid ? 'is-invalid' : 'border-white'">
              {{form.controls.totalActuatorCurrentConsumption.value}}
            </div>
            <div class="invalid-feedback">
              {{ form.controls.totalActuatorCurrentConsumption.errors?.messageKey | translate:{'0':form.controls.totalActuatorCurrentConsumption.errors?.param} }}
            </div>
          </div>
        </div>

        <div *ngIf="form.controls.totalInternalSensorCurrentConsumption">
          <p class="font-weight-bold">{{'settingsTabNavigator.label.available_current_bus_750_753' | translate}}</p>
          <div class="mb-3 row">
            <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.actuators_carryover_750_753' | translate}}:</label>
            <div class="col-md-8">
              <div class="form-control break-all" [ngClass]="form.controls.totalInternalSensorCurrentConsumption.invalid ? 'is-invalid' : 'border-white'">
                {{form.controls.totalInternalSensorCurrentConsumption.value}}
              </div>
              <div class="invalid-feedback">
                {{ form.controls.totalInternalSensorCurrentConsumption.errors?.messageKey | translate:{'0':form.controls.totalInternalSensorCurrentConsumption.errors?.param} }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!potantialFix">
        <p class="font-weight-bold">{{'settingsTabNavigator.label.potential' | translate}}</p>
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.potential.ToUse' | translate}}:</label>
          <div class="col-md-8">
            <div class="w-100">
              <input class="form-control break-all" type="text" [class.is-invalid]="form.controls['potentialToUse']?.invalid"
                formControlName="potentialToUse" inputRestricter="^[0-9]*$" (inputEvent)="form.controls['potentialToUse']?.setValue($event)">
              <div class="invalid-feedback">
                {{ form.controls.potentialToUse.errors?.messageKey | translate:{'0':form.controls.potentialToUse.errors?.param} }}
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3 row" *ngIf="form.controls.potentialValueLabel">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.potential.module' | translate}}:</label>
          <div class="col-md-8">
            <div class="form-control break-all" [ngClass]="form.controls.potentialValueLabel.invalid ? 'is-invalid' : 'border-white'">
              {{form.controls.potentialValueLabel.value}}
            </div>
            <div class="invalid-feedback">
              {{ form.controls.potentialValueLabel.errors?.messageKey | translate:{'0':form.controls.potentialValueLabel.errors?.param} }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="potantialFix && form.controls.potentialValueLabel">
        <p class="font-weight-bold">{{'settingsTabNavigator.label.potential' | translate}}</p>
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label text-end">{{'settingsTabNavigator.label.potential.module' | translate}}:</label>
          <div class="col-md-8">
            <div class="form-control break-all" [ngClass]="form.controls.potentialValueLabel.invalid ? 'is-invalid' : 'border-white'">
              {{form.controls.potentialValueLabel.value}}
            </div>
            <div class="invalid-feedback">
              {{ form.controls.potentialValueLabel.errors?.messageKey | translate:{'0':form.controls.potentialValueLabel.errors?.param} }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" (click)="save()" *ngIf="form && (channeldataProvider?.length || !potantialFix)">
    {{'global.label.apply' | translate}}
  </button>
</div>
